const Like = () => {
  return (
    <svg
      width="73"
      height="73"
      viewBox="0 0 73 73"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_118_124"
        style={{
          maskType: "alpha",
        }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="73"
        height="73"
      >
        <rect
          x="0.542236"
          y="0.542236"
          width="71.903"
          height="71.903"
          fill="#D9D9D9"
        />
      </mask>
      <g mask="url(#mask0_118_124)">
        <path
          d="M26.4574 52.2975L46.5303 52.2975L46.5303 50.6497L26.4574 50.6497L26.4574 52.2975ZM26.4574 44.8076L46.5303 44.8076L46.5303 43.1598L26.4574 43.1598L26.4574 44.8076ZM36.4938 36.9432C39.4898 34.2967 41.8741 32.2495 43.6467 30.8015C45.4193 29.3534 46.3056 27.456 46.3056 25.1091C46.3056 23.8608 45.8811 22.8122 45.0323 21.9634C44.1834 21.1145 43.1348 20.6901 41.8865 20.6901C40.3886 20.6901 39.34 21.0396 38.7408 21.7387C38.1416 22.4378 37.3926 23.3365 36.4938 24.4351C35.595 23.3365 34.846 22.4378 34.2468 21.7387C33.6477 21.0396 32.5991 20.6901 31.1011 20.6901C29.8528 20.6901 28.8042 21.1145 27.9553 21.9634C27.1065 22.8122 26.6821 23.8608 26.6821 25.1091C26.6821 27.456 27.5434 29.316 29.2661 30.6891C30.9887 32.0623 33.398 34.147 36.4938 36.9432ZM52.5222 62.5586L20.4654 62.5586C19.317 62.5586 18.3558 62.1716 17.5818 61.3977C16.8079 60.6237 16.4209 59.6625 16.4209 58.5141L16.4209 14.4735C16.4209 13.325 16.8079 12.3638 17.5818 11.5899C18.3558 10.8159 19.317 10.429 20.4654 10.429L52.5222 10.429C53.6706 10.429 54.6318 10.8159 55.4058 11.5899C56.1797 12.3638 56.5667 13.325 56.5667 14.4735L56.5667 58.5141C56.5667 59.6625 56.1797 60.6237 55.4058 61.3977C54.6318 62.1716 53.6706 62.5586 52.5222 62.5586Z"
          fill="#EAE0D5"
        />
      </g>
    </svg>
  );
};

const ProfileCard = ({ user, classes }) => {
  return (
    <div
      className={"profile__card " + classes}
      style={{
        backgroundColor: user.bgColor,
      }}
    >
      <div className={`profile__card__avatar`}>
        <img src={user.avatar} alt="avatar" 

            style={{
                backgroundColor: user.avatarFill,
                borderRadius: "16px",
            }}
        />
      </div>

      <h1>{user.name}</h1>
      <p>{user.email}</p>

      <div className="profile__card__like">
        <Like />
      </div>
    </div>
  );
};

export default ProfileCard;
